import { Bounce,Linear, Power3, Power2,Power0, gsap} from 'gsap';
import { BLEND_MODES } from 'pixi.js';
import { ISymbolAnimationConf, ReelBaseSymbol } from '../../../core/reel/symbol/ReelBaseSymbol';
import { Sequence } from '../../../core/displayobject/Sequence';
import { ParticleController } from '../../presentations/independent/particles/ParticleController';
import { Helper } from '../../../core/utils/Helper';
import { MathHelper } from '../../../core/utils/MathHelper';
import { AnimationEffects } from '../../../core/effects/AnimationEffects';
import { PunkSymbolData } from './PunkSymbolData';
import { PunkRocker } from '../../PunkRocker';

export enum WinShowStates {
    GLOW,
    IDLE,
    BIGWIN_START,
    WIN
}

export class PunkWinSymbol extends ReelBaseSymbol {

    private glow: PIXI.Sprite;
    private win_frame: Sequence;
    private win_frame_Crack: Sequence;
    private win_FX: Sequence;
    private readonly _symbolName: string;

    private Particle: ParticleController;

    public get symbolHeight(): number {
        return this.sizeType.value;
    }

    public get symbolWidht(): number {
        return PunkSymbolData.DEFAULT_DIM.WIDTH;
    }

    public get symbolSizeY(): number {
        return (this.symbolHeight * this.scale.y);
    }

    public get symbolSizeX(): number {
        return (this.symbolWidht * this.scale.x);
    }

    // setCrackWindow():void{
    //     this.win_frame_Crack.setTexture("FX_Shatter/Shatter_" + ["A","B","C","D"][MathHelper.randomIntInRange(0,4)]);
    // }

    changeState(newStateConfig: ISymbolAnimationConf): gsap.core.Timeline | undefined { return undefined };

    constructor(ID: number, symName: string, state: any, sizeType: number, symTexture: PIXI.Texture) {
        super(ID, state, sizeType);
        this._symbolName = symName;
        this.init(symTexture);
    }

    private init(symTexture: PIXI.Texture): void {
        this._mainSp = this.addChild(new PIXI.Sprite(symTexture));
        this._mainSp.anchor.set(0.5, 0.5);

        let sizeToShow: number = (this.sizeType.value >= 7) ? 7 : this.sizeType.value;

        //todo need to check this
        if(sizeToShow === 0) {
            debugger;
        }

        if(this._symbolName === "XWILD") {
            sizeToShow = 4;
        }
        
        this.win_frame = this.addChild(new Sequence({texturePath:"Win_Frames/Frame_"+ sizeToShow}));
        this.win_frame.anchor.set(0.5,0.5);

        this.win_FX = this.addChild(new Sequence({texturePath:"BigWinFireLoop"}));
        this.win_FX.anchor.set(0.5,0.5);
        this.win_FX.blendMode = BLEND_MODES.ADD;
        this.win_FX.scale.set(1.3, PunkSymbolData.fetchSizeTimesSize(sizeToShow) * 1.1); // #306

        this.win_frame_Crack = this.addChild(new Sequence({texturePath:"FX_Shatter/Shatter_" + ["A","B","C","D"][MathHelper.randomIntInRange(0,3)]}));
        this.win_frame_Crack.anchor.set(0.5,0.5);
        this.win_frame_Crack.blendMode = BLEND_MODES.ADD;
        this.win_frame_Crack.scale.y = PunkSymbolData.fetchSizeTimesSize(sizeToShow);

        PunkRocker.overlayAnim.addChild(this);

        this.visible = false;
    }

    Play(lvl: number, durr: number = 0.25): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
            onStart: () => {this.visible = true},
            // onComplete: () => {this.visible = false},
        }), true);

        this.showAnimState(WinShowStates.WIN, lvl);
        this._timeLine.add(this.win_frame.play({duration:durr}),0);

        this._timeLine.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr / 4 }, 0);

        this._timeLine.fromTo(this.scale, { x: 0.85, y: 0.85 }, { x: 1.15, y: 1.15, duration: durr / 3, ease: "power3.out" }, 0);
        this._timeLine.to(this.scale, { x: 1, y: 1, duration: durr / 3 * 2, ease: "bounce.out" }, durr / 3);

        return this._timeLine;
    }

    FrameMultApply(durr: number = 0.25): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
            onStart: () => {this.visible = true}
        }), true);

        this.showAnimState(WinShowStates.BIGWIN_START, 2);

        this._timeLine.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr / 4 }, 0)

        return this._timeLine;
    }

    BigWinStart(durr: number = 0.25): gsap.core.Timeline {

        this._timeLine = this.Play(1,durr);

        this.showAnimState(WinShowStates.BIGWIN_START, 2);

        const startPos: PIXI.Point = MathHelper.pointAdd(this.position,0);
        this._timeLine.add(this.win_FX.play({repeat:-1}));

         this._timeLine.add(() => {
             AnimationEffects.Shake({
                 x: 2,
                 y: 2,
                 obj: this,
                 hertz: 180,
                 duration: durr,
                 Intensity: 1.7,
                 positionCb: () => startPos,
                 ease: Power2.easeOut,
             })},0);
        return this._timeLine;
    }
 

    // BigWinStart(durr: number = 0.25): gsap.core.Timeline {
    //     this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
    //         onStart: () => {this.visible = true},
    //         onComplete:() => {
    //             // this.win_FX.setTexture("Win_Fire_Frame_Loop");
    //             // this.win_FX.play({repeat:-1});
    //         }
    //         // onComplete:() => this.Glow(0.25,3,1)
    //     }), true);

    //     this.showAnimState(WinShowStates.BIGWIN_START, 2);
    //     this.alpha = 1;

    //     const startPos: PIXI.Point = MathHelper.pointAdd(this.position,0);

    //     this._timeLine.add(
    //         AnimationEffects.Shake({
    //             x: 0.5,
    //             y: 1.5,
    //             obj: this,
    //             hertz: 80,
    //             duration: this.win_FX.totalDuration*2,
    //             Intensity: 1.7,
    //             positionCb: () => startPos,
    //             ease: Power2.easeOut
    //         }).play(),0
    //     );
        
    //     this._timeLine.add(() => {this.win_FX.visible = true}, this.win_FX.totalDuration)
    //     this._timeLine.add(this.win_FX.play({duration:this.win_FX.totalDuration*2}),this.win_FX.totalDuration);
    //     this._timeLine.add(() => {
    //         this.win_FX.setTexture("Win_Fire_Frame_Loop");
    //         this.win_FX.play({repeat:-1,duration:this.win_FX.totalDuration*2});
    //     },"-="+this.win_FX.totalDuration)
        
    //     // this._timeLine.add(() => this.Particle.enableEmit(true), 0);

    //     return this._timeLine;
    // }

    // Glow(durr: number = 0.25, lvl: number,sizeY:number): gsap.core.Timeline {
    //     this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
    //         onStart: () => {this.visible = true},
    //         onComplete: () => {this.visible = false}
    //     }), true);

    //     if (!this.glow) {
    //         this.glow = this.addChild(new PIXI.Sprite())
    //         this.glow.scale.y = sizeY;
    //         this.glow.anchor.set(0.5, 0.5);
    //         this.glow.blendMode = BLEND_MODES.ADD;
    //     }   

    //     this.glow.texture = (PunkRocker.assetLoader.getTextures("Win_Blink/Frame_"+ ["A","B","C","D"][lvl])[0]);

    //     this.showAnimState(WinShowStates.GLOW);

    //     this._timeLine.fromTo(this, { alpha: 0.8 }, { alpha: 0, duration: durr }, 0);
    //     // if(lvl > 1){
    //     //     this._timeLine.fromTo(this, { alpha: 0 }, { alpha: 0.8, duration: durr / 2 }, 0)
    //     //     this._timeLine.fromTo(this, { alpha: 0.8 }, { alpha: 0, duration: durr / 2 }, durr / 2);
    //     // }else{
    //     //     this._timeLine.fromTo(this, { alpha: 0.8 }, { alpha: 0, duration: durr }, 0);
    //     // }

    //     return this._timeLine;
    // }

    showAnimState(state: WinShowStates, winLvl?: number) {
        this.children.forEach(s => s.visible = false);

        switch (state) {
            case WinShowStates.GLOW:
                this.glow.visible = true;
                return;
            case WinShowStates.WIN:
                // this.win_FX.setTexture("Win_FX");
                this.win_frame.visible = true;
                this._mainSp.visible = false;
                this.win_frame_Crack.visible = true;
                return;
            case WinShowStates.BIGWIN_START:
                this._mainSp.visible = false;
                this.win_frame.visible = true;
                this.win_FX.visible = true;
                this.win_frame_Crack.visible = true;
                // this.win_FX.setTexture("Win_Fire_Frame");
                if (this.Particle) this.Particle.visible = true;
                return;
            case WinShowStates.IDLE:
                // this.win_FX.setTexture("Win_FX");
                this.win_frame.visible = true;
                this._mainSp.visible = false;
                return;
        }
    }

    Idle(durr: number,texture:PIXI.Texture) {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({
            onStart: () => {this.visible = true},
            onComplete: () => {this.visible = false}
        }), true);

        this._mainSp.texture = texture;
        this.showAnimState(WinShowStates.IDLE);

        this._timeLine.add(this.win_frame.play(),0);

        this._timeLine.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr / 4 },0);
        this._timeLine.to(this, { alpha: 0, duration: durr / 4 }, durr / 4 * 3);
    }

    Stop(duration: number):gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete: () => { this.visible = false /*this.win_FX.stop(true) */} }), true);
        this._timeLine.fromTo(this, { alpha: 1 }, { alpha: 0, duration: duration }, 0);
        return this._timeLine;
    }

    remove(): void {
        this.Stop(0.01);
        if (this._timeLine) this._timeLine.totalProgress(1);
        if (this.Particle) this.Particle.remove();
        this.destroy({ children: true });
    }
}